import { GraphQLQueryClass, TUser } from "@harea/component";

export class EmployeeGenderQuery
    implements GraphQLQueryClass<TUser, TResponse>
{
    queryKey: string = "Harea.TimeOff.Employee.Gender.Query";

    gql: string = `
        query EmployeeGenderQuery($employeeId: Float) {
            users(filter: { data: { id: $employeeId } }) {
                data {
                    id
                    employee {
                        gender
                    }
                }
            }
        }
    `;

    variables?: any;

    constructor(variables?: any) {
        this.variables = variables;
    }

    mapFn(data: TResponse): TUser | null {
        return data.users.data[0] ?? null;
    }
}

export type TResponse = {
    users: {
        data: Array<TUser>;
    };
};
